"use client";

import React, { useEffect } from "react";
import { useDialogStore } from "@/store/dialogStore";
import ToastContainer from "./ToastContainer";

const ConfirmDialog: React.FC = () => {
  const confirm = useDialogStore((state) => state.confirm);
  const resolveConfirm = useDialogStore((state) => state.resolveConfirm);

  useEffect(() => {
    if (!confirm.isOpen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        resolveConfirm(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [confirm.isOpen, resolveConfirm]);

  if (!confirm.isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/70 z-[60]"
      onClick={() => resolveConfirm(false)}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h5 className="text-lg font-semibold text-primary mb-2">
          {confirm.title}
        </h5>
        <p className="text-gray-700 mb-6">{confirm.message}</p>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-md bg-primary text-white transition hover:bg-hover_primary hover:cursor-pointer"
            onClick={() => resolveConfirm(false)}
          >
            {confirm.cancelText}
          </button>
          <button
            className="px-4 py-2 rounded-md border border-primary text-primary hover:bg-lightBlue hover:cursor-pointer transition"
            onClick={() => resolveConfirm(true)}
          >
            {confirm.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

const DialogProvider: React.FC = () => {
  return (
    <>
      <ToastContainer />
      <ConfirmDialog />
    </>
  );
};

export default DialogProvider;
